export const typesSign = {
  AUTOGRAPH: 'Signly',
  FEA: 'FEA',
  FAB: 'FAB'
};
